import { useSearchParams, Link } from 'react-router-dom'
import logoImage from '@assets/images/logo_L.png'
import ResetPasswordForm from './components/ResetPasswordForm'

function ResetPassword() {
  const [searchParams] = useSearchParams()
  const oobCode = searchParams.get('oobCode')

  return (
    <div className="login-container">
      <div className="login-card">
        <img src={logoImage} alt="IROGAMI" className="login-logo" />
        {oobCode ? (
          <>
            <h2 className="change-password-title">
              新しいパスワードを<br />設定してください
            </h2>
            <ResetPasswordForm />
          </>
        ) : (
          <div className="reset-password-invalid">
            <p>無効なリンクです。</p>
            <p>パスワードを再設定する場合は、ログイン画面から「パスワードを忘れた場合」より再度メールを送信してください。</p>
            <Link to="/login" className="link-text">
              ログイン画面へ
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}

export default ResetPassword
